import { Expose, plainToInstance } from "class-transformer";
import camelcaseKeys from "camelcase-keys";

export class DiscountCouponModel {
  @Expose()
  public discountCouponId?: number;

  @Expose()
  public code?: string;

  @Expose()
  public expireDate?: string;

  @Expose()
  public type?: number;

  @Expose()
  public amount?: number;

  @Expose()
  public discountPercent?: number;

  @Expose()
  public discountPercentMaxAmount?: number;

  @Expose()
  public customerId?: number;

  @Expose()
  public isActive?: boolean;

  @Expose()
  public discountPercentMinAmount?: number;

  @Expose()
  public usageLimit?: number;

  @Expose()
  public usageCount?: number;

  public static toClass(data: object) {
    //@ts-ignore
    return plainToInstance(DiscountCouponModel, camelcaseKeys(data, { deep: true }), { excludeExtraneousValues: true });
  }

  public static toArrayOfClass(data: object[]) {
    //@ts-ignore
    return plainToInstance(DiscountCouponModel, camelcaseKeys(data, { deep: true }) as DiscountCouponModel[], { excludeExtraneousValues: true });
  }
}
